import { render, staticRenderFns } from "./SCRecord.vue?vue&type=template&id=beb0f898&scoped=true&"
import script from "./SCRecord.vue?vue&type=script&lang=js&"
export * from "./SCRecord.vue?vue&type=script&lang=js&"
import style0 from "./SCRecord.vue?vue&type=style&index=0&id=beb0f898&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb0f898",
  null
  
)

export default component.exports